<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button v-if="$hasPermission('zone.add')" class="float-right" @click="newModel" >Nueva area</b-button>
					<h2>Zonas de operación</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'zoned-areas-index-list') } ">
						<div class="row">
							<b-form-group class="col-2" label="Buscar">
								<b-form-input v-model="filters.search" type="text" />
							</b-form-group>
							<b-form-group class="col-2" label="Zonas">
								<b-form-select size="sm" class="ml-2" id="zones-types"
									v-model="filters.zoneType" :options="zonesTypes" >
								</b-form-select>
							</b-form-group>
							<b-form-group class="col-2" label=".">
								<b-button type="submit" variant="primary">Buscar</b-button>
							</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						permission-show="zone.show"
						id="zoned-areas-index-list"
						:filters="filters"
						:columns="modelColumns"
						resource="zoned-areas"
					>
						<template #cell(name)="row">
							<span v-b-tooltip.hover class="text-info" title="Zona maestra" v-if="row.item.masterArea"><md-icon icon="beenhere"/></span>
							{{ row.item.name }}
						</template>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<a v-if="$hasPermission('zoneArea.show')"  class="btn btn-sm mr-1 btn-warning" target="_blank" :href="`/zoned-areas-edit?id=${row.item.id}`" >
									<md-icon icon="location_on" />
								</a>
								<b-button @click="(event) => modelView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="primary">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('zone.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
								<b-button v-if="$hasPermission('zoneArea.show')" @click="(event) => openDetails(row.item)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="info" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</div>
				<hr>
			</div>
			<b-modal
				hide-footer
				static
				id="modal-zoned-areas-view"
				size="lg"
				:title="modalInfo.modelId > 0 ? 'Edición de Zona de Operacion' : 'Nueva Zona de Operacion'"
				>
				<Single :unableEdit.sync="unableEdit" :model-id="modalInfo.modelId" @modal-id="modalInfo.modelId = $event" modal-id="modal-zoned-areas-view"/>
			</b-modal>
			<SingleResumeZonedArea v-model="showResumeModule"  ref="single-resume" />
		</MainLayout>
		
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'
import SingleResumeZonedArea from "./Resume/Single.vue"

export default {
		components: { MainLayout, Single, AjaxTable,SingleResumeZonedArea },
		data(){
			return {
				unableEdit: false,
				modalInfo : {
					modelId:-1,
					title:"Destino",
				},
				filters : {
					search:'',
					zoneType: ''
				},
				modelColumns : [
					{key:'id',label:'ID'},
					{key:'name',label:'Nombre'},
					{key:'zonesType',label:'Zonificacion'},
					{key:'description',label:'Descripcion'},
					{key:'actions',label:'Acciones'},
				],
				zonesTypes: [
					{value:"", text: 'Todas las zonas'},
					{value:"maestras", text: 'Zonas maestras'},
					{value:"proveedores", text: 'Zonas proveedor'},
				],
				showResumeModule:false
			}
		},
		methods:{
			modelView(item,index,event){
				this.unableEdit = !this.$hasPermission('zone.edit')
				this.modalInfo.modelId = item.id
				this.$root.$emit('bv::show::modal', "modal-zoned-areas-view", event.target)
			},
			newModel(event){
				this.unableEdit = false
				this.modalInfo.modelId = -1
				this.$root.$emit('bv::show::modal', "modal-zoned-areas-view", event.target)
			},
			modelDelete(item){
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/zoned-areas/${item.id}`).then((response) => {

							if(response.data.error) {
								this.$root.showAlert(response.data.message, { variant: 'warning' })
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!',{variant:'warning'})
							this.$root.$emit('bv::refresh::table', 'zoned-areas-index-list')
							close()

						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			},
			openDetails(item){
				this.showResumeModule = true;
				this.$refs['single-resume'].loadModel(item.id)
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
